import React, { useState, useEffect } from 'react';
import useFetch from "../../services/useFetch.js"
import CategoryFilter from './Helper/CategoryFilter.jsx';
import GetData from '../../services/GetData.js';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import MetricCard from '../ui/MetricCard';
import { tokens } from '../../theme';

export default function ExpensiveIngredient({ startDate, endDate, reload, showLoad }) {
    const [val, setVal] = useState(null);
    const [name, setName] = useState('');
    const [categoryFilter, setCategoryFilter] = useState(null);
    const [filtData, setFiltData] = useState(null);
    const [catBool, setCatBool] = useState(false);
    const [busy, setBusy] = useState(true);

    const apiUrl = `api/expensive-item?startDateStr=${startDate}&endDateStr=${endDate}`;
    const { data } = useFetch(apiUrl, reload);

    useEffect(() => {
        if (data == null) return;
        if (filtData != null && catBool) {
            setVal(filtData.unitPrice);
            setName(filtData.ingredient || '');
            setBusy(false);
            return;
        }
        setVal(data.unitPrice ?? null);
        setName(data.ingredient || '');
        setBusy(false);
        showLoad?.();
    }, [data, filtData, catBool]);

    const categoryNameFilter = async (filter) => {
        setCatBool(true);
        setCategoryFilter(filter);
        setBusy(true);
        const { getData, error } = await GetData(
            'api/expensive-filtered-item',
            filter,
            'filterCategory',
            startDate,
            endDate,
        );
        if (error) console.log(error);
        else setFiltData(getData);
        setBusy(false);
    };

    const clearFilter = () => {
        setCatBool(false);
        setFiltData(null);
        setCategoryFilter(null);
    };

    const displayVal = val != null && Number(val) > 0
        ? `$${Number(val).toFixed(2)}`
        : (val === 'N/a' || val == null ? '—' : String(val));

    return (
        <MetricCard
            label="Most expensive ingredient"
            loading={busy}
            value={displayVal}
            detail={name || 'No data for dates'}
            action={<CategoryFilter category={categoryNameFilter} />}
        >
            {catBool && categoryFilter && (
                <Box sx={{ mt: 0.5 }}>
                    <Chip
                        label={categoryFilter}
                        size="small"
                        variant="outlined"
                        onDelete={clearFilter}
                        sx={{ borderColor: tokens.border, color: tokens.inkMuted }}
                    />
                </Box>
            )}
        </MetricCard>
    );
}
